import Hero from './components/Hero'
import About from './components/About'
import Work from './components/Work'
import Skills from './components/Skills'
import Contact from './components/Contact'
import "./styles/Main.scss";
import Experience from './components/Experience'
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <main>
      <Analytics/>
      <Hero />
      <About/>
      <Work />
      <Skills />
      <Experience />
      <Contact />
    </main>
  );
}

export default App;
